import React, { useEffect, useRef } from 'react';
import { Modal } from '@components/common/Modal';

export function ConsultationDialog({ title, onClose, children, isOpen = true }: { title: string; onClose(): void; children: React.ReactNode; isOpen?: boolean }) {
  const content = useRef<HTMLDivElement>(null);
  useEffect(() => {
    if (!isOpen) return;
    const previous = document.activeElement as HTMLElement | null;
    const dialog = content.current?.closest('[data-consultation-dialog]') ?? content.current?.parentElement?.parentElement;
    dialog?.setAttribute('role', 'dialog'); dialog?.setAttribute('aria-modal', 'true'); dialog?.setAttribute('aria-label', title);
    content.current?.focus();
    const trap = (event: KeyboardEvent) => {
      if (event.key !== 'Tab' || !dialog) return;
      const targets = [...dialog.querySelectorAll<HTMLElement>('button:not(:disabled), textarea:not(:disabled), input:not(:disabled), a[href], [tabindex="0"]')];
      if (!targets.length) { event.preventDefault(); return; }
      const first = targets[0], last = targets[targets.length - 1];
      if (event.shiftKey && (document.activeElement === first || document.activeElement === content.current)) { event.preventDefault(); last.focus(); }
      else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
    };
    document.addEventListener('keydown', trap);
    return () => { document.removeEventListener('keydown', trap); if (previous?.isConnected) previous.focus(); };
  }, [title, isOpen]);
  return <Modal isOpen={isOpen} keepMounted title={title} onClose={onClose} closeOnOverlayClick={false}><div ref={content} tabIndex={-1}>{children}</div></Modal>;
}
